import { useCallback } from "react";
import { PressableScale } from "pressto";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { StyleSheet } from "react-native-unistyles";
import { showInfoToast } from "@src/utils/toast";
import { useEnvironment, resetEnvironment } from "@src/config/environment-store";
import { environment } from "@src/config/runtime";

/**
 * Displays the current environment with a reset button when not using the default.
 * Only renders when a non-default environment is active (dev feature).
 */
export function EnvironmentResetBadge() {
  const env = useEnvironment();
  const defaultEnv = environment();
  const isNonDefaultEnvironment = env.fqdn !== defaultEnv.fqdn;

  const handleResetEnvironment = useCallback(async () => {
    await resetEnvironment();
    showInfoToast({ message: `Reset to ${defaultEnv.fqdn}` });
  }, [defaultEnv.fqdn]);

  if (!isNonDefaultEnvironment) {
    return null;
  }

  return (
    <View alignItems="center" mt="lg">
      <PressableScale onPress={handleResetEnvironment} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
        <View flexDirection="row" alignItems="center" gap="xs">
          <Text textStyle="xs/regular" style={styles.environmentText}>
            {env.fqdn}
          </Text>
          <Text textStyle="xs/regular" style={styles.resetText}>
            (reset)
          </Text>
        </View>
      </PressableScale>
    </View>
  );
}

const styles = StyleSheet.create((theme) => ({
  environmentText: {
    color: theme.colors.interactive.buttons.default_foreground,
    opacity: 0.6,
  },
  resetText: {
    color: theme.colors.interactive.controls.secondary_foreground,
    opacity: 0.8,
  },
}));
